export class ActivityService {
  static $inject = ['$resource'];

  private resource: any;

  constructor($resource) {
    this.resource = $resource(
      '/api/activities/:id',
      { id: '@id' },
      { update: { method: 'PUT' } },
    );
  }

  query(queryParams) {
    return this.resource.query(queryParams).$promise;
  }

  create(activity) {
    return new this.resource(activity);
  }

  save(activity) {
    return activity.$save();
  }

  update(activity) {
    return activity.$update();
  }

  remove(...args) {
    return this.resource.remove(...args);
  }
}
